import {
  LayoutsInput
}  from 'src/services/graphql/Models';
import Layout from './Layout';
import { Parsable } from 'src/shared/utility';

export default class Layouts implements LayoutsInput, Parsable {
  lg: Array< Layout >;
  md: Array< Layout >;
  sm: Array< Layout >;
  xs: Array< Layout >;
  
  constructor ( _from: any ) { 
    const from = _from || {};
    this.lg = (from.lg || []).map(o => new Layout(o));
    this.md = (from.md || []).map(o => new Layout(o));
    this.sm = (from.sm || []).map(o => new Layout(o));
    this.xs = (from.xs || []).map(o => new Layout(o));
  }

  parseAbsolute() {
    return {
      lg: this.lg.map(o => o.parseAbsolute()),
      md: this.md.map(o => o.parseAbsolute()),
      sm: this.sm.map(o => o.parseAbsolute()),
      xs: this.xs.map(o => o.parseAbsolute()),
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/Layouts.ts